import React, { ReactElement } from "react";
import { Provider as ReduxProvider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { history } from "./services/history";
import CustomHistoryRouter from "./routes/CustomHistoryRouter";
import AppRoutes from "./routes/Router";
import { store } from "./redux/store";
import { GoogleTagManager } from "./components/GoogleTagManager";

function App(): ReactElement {
  return (
    <HelmetProvider>
      <GoogleTagManager />
      <CustomHistoryRouter history={history}>
        <ReduxProvider store={store}>
          <div className="App flex flex-col h-screen overflow-y-auto overflow-x-hidden">
            <AppRoutes />
            <ToastContainer
              position="bottom-right"
              theme="light"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              rtl={false}
              transition={Bounce}
              closeOnClick
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </div>
        </ReduxProvider>
      </CustomHistoryRouter>
    </HelmetProvider>
  );
}

export default App;
